import React from 'react';
import SectionTitle from '../SectionTitle/SectionTitle';
import Text from '../Text/Text';
import Square from '../Square/Square';
import './Services.css';
import COS_ICON_HEALTH from '../../images/COS_ICON_HEALTH.png';
import COS_ICON_HEART from '../../images/COS_ICON_HEART.png';
import COS_ICON_PERFORMANCE from '../../images/COS_ICON_PERFORMANCE.png';
import COS_ICON_JOIN from '../../images/COS_ICON_JOIN.png';
import COS_ICON_CHAT from '../../images/COS_ICON_CHAT.png';
import COS_ICON_ROCKET from '../../images/COS_ICON_ROCKET.png';

const values = [
  {
    image: COS_ICON_HEALTH,
    label: 'Proximité',
  },
  {
    image: COS_ICON_HEART,
    label: 'Équité',
  },
  {
    image: COS_ICON_PERFORMANCE,
    label: 'Performance',
  },
  {
    image: COS_ICON_JOIN,
    label: 'Indépendance',
  },
  {
    image: COS_ICON_CHAT,
    label: 'Transparence',
  },
  {
    image: COS_ICON_ROCKET,
    label: 'Engagement',
  },
];

const Services = () => {
  return (
    <div className="Services">
      <div className="Services__infos">
        <SectionTitle classname="Services__title" greenLight={true}>
          Nos services
        </SectionTitle>
        <Text className="Services__text">
          De nombreux services dans nos pharmacies : orthopédie, contention,
          maintien à domicile, vaccination, téléconsultation
        </Text>
      </div>
      <div className="Services__squares">
        {values.map((value, index) => (
          <Square
            key={index}
            label={value.label}
            image={value.image}
            className="Services__square"
          />
        ))}
      </div>
    </div>
  );
};

export default Services;
